import React from 'react';
import {isMobile} from 'react-device-detect';

export default function Step(props) {
  const {stepTitle, stepValue, stepNumber, currentStep, index} = props;

  const getStepDesign = () => (currentStep === index ? 'current' : '');

  return (
    <div className={`idf-step ${getStepDesign()}`}>
      <span className='step-progress' />
      {!isMobile && <span className='step-title'> {stepTitle}</span>}
    </div>
  );
}
